"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function SvgComponent(props) {
    const { fill = 'none' } = props, restProps = __rest(props, ["fill"]);
    return (react_1.default.createElement("svg", Object.assign({ "aria-hidden": 'true', focusable: 'false', className: `fl-${fill}`, width: 24, height: 24, viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg' }, restProps),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M15.77 7.77002C15.77 8.18423 15.4342 8.52002 15.02 8.52002H10.0638C9.95336 8.52002 9.86382 8.60956 9.86382 8.72002C9.86382 8.77306 9.88489 8.82393 9.92239 8.86144L16.77 15.7093C17.0629 16.0022 17.0629 16.4771 16.77 16.77C16.4771 17.0629 16.0022 17.0629 15.7093 16.77L8.86141 9.92242C8.7833 9.84432 8.65667 9.84432 8.57856 9.92243C8.54106 9.95994 8.51999 10.0108 8.51999 10.0638V15.02C8.51999 15.4342 8.1842 15.77 7.76999 15.77C7.35578 15.77 7.01999 15.4342 7.01999 15.02V7.42002C7.01999 7.19911 7.19908 7.02002 7.41999 7.02002H15.02C15.4342 7.02002 15.77 7.35581 15.77 7.77002Z' })));
}
exports.default = SvgComponent;
